"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Promos = _interopRequireDefault(require("./Promos"));
var _HotelCard = require("./HotelCard.proptypes");
var _PriceInfo = _interopRequireDefault(require("./PriceInfo"));
var _Icon = _interopRequireDefault(require("@airasia/phoenix-components/components/Icon"));
var _Label = _interopRequireDefault(require("@airasia/phoenix-components/components/Label"));
var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "PriceDetails__Wrapper",
  componentId: "sc-16umxym-0"
})(["display:flex;height:100%;flex-direction:", ";", ";padding-bottom:", ";"], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? 'row' : 'column';
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile && 'justify-content: space-between';
}, function (_ref3) {
  var theme = _ref3.theme,
    isMobile = _ref3.isMobile,
    lowInventoryAlert = _ref3.lowInventoryAlert;
  return !lowInventoryAlert && isMobile ? theme.space.small : 0;
});
var Facility = _styledComponents.default.div.withConfig({
  displayName: "PriceDetails__Facility",
  componentId: "sc-16umxym-1"
})(["display:flex;align-items:flex-start;color:", ";line-height:", ";"], function (_ref4) {
  var theme = _ref4.theme,
    color = _ref4.color;
  return theme.colors[color];
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.lineHeight.small;
});
var Facilities = _styledComponents.default.div.withConfig({
  displayName: "PriceDetails__Facilities",
  componentId: "sc-16umxym-2"
})(["width:45%;padding-left:16px;padding-top:12px;position:relative;"]);
var LowInventoryAlert = _styledComponents.default.div.withConfig({
  displayName: "PriceDetails__LowInventoryAlert",
  componentId: "sc-16umxym-3"
})(["display:flex;align-items:center;padding:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return "0 0 ".concat(theme.space.small, " ").concat(theme.space.small);
});
var PriceDetails = function PriceDetails(_ref7) {
  var salesTag = _ref7.salesTag,
    bigPointPromo = _ref7.bigPointPromo,
    discountText = _ref7.discountText,
    strikeThrough = _ref7.strikeThrough,
    price = _ref7.price,
    priceText = _ref7.priceText,
    perGuestText = _ref7.perGuestText,
    snapPriceText = _ref7.snapPriceText,
    totalPrice = _ref7.totalPrice,
    isAmenityFocused = _ref7.isAmenityFocused,
    promoTag = _ref7.promoTag,
    amenityRowCount = _ref7.amenityRowCount,
    isMobile = _ref7.isMobile,
    facilities = _ref7.facilities,
    theme = _ref7.theme,
    locale = _ref7.locale,
    lowInventoryAlert = _ref7.lowInventoryAlert,
    isCarouselCard = _ref7.isCarouselCard;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Wrapper, {
      isMobile: isMobile,
      lowInventoryAlert: lowInventoryAlert
    }, !isMobile && /*#__PURE__*/_react.default.createElement(_Promos.default, {
      salesTag: salesTag,
      bigPointPromo: bigPointPromo,
      isAmenityFocused: isAmenityFocused,
      promoTag: promoTag,
      amenityRowCount: amenityRowCount
    }), isMobile && !isCarouselCard && /*#__PURE__*/_react.default.createElement(Facilities, null, facilities &&
    // eslint-disable-next-line react/prop-types
    facilities.map(function (facility, index) {
      var color = index === 0 ? 'tertiary' : 'greyDark';
      var textColor = index === 0 ? 'tertiaryDark' : 'greyDark';
      return /*#__PURE__*/_react.default.createElement(Facility, {
        color: color
      }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
        icon: "CheckIcon",
        color: color,
        padding: "2px"
      }), /*#__PURE__*/_react.default.createElement(_Label.default, {
        textColor: textColor,
        customProperties: {
          noPadding: true,
          noTextAlign: true
        }
      }, facility));
    })), /*#__PURE__*/_react.default.createElement(_PriceInfo.default, {
      discountText: discountText,
      strikeThrough: strikeThrough,
      price: price,
      priceText: priceText,
      perGuestText: perGuestText,
      snapPriceText: snapPriceText,
      totalPrice: totalPrice,
      isMobile: isMobile,
      theme: theme,
      locale: locale
    })), isMobile && !isCarouselCard && lowInventoryAlert && /*#__PURE__*/_react.default.createElement(LowInventoryAlert, null, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: "ErrorOutlineIcon",
      color: "primary",
      fontsize: "normal"
    }), /*#__PURE__*/_react.default.createElement(_Label.default, {
      textColor: "primary"
    }, " ", lowInventoryAlert, " ")));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
PriceDetails.propTypes = _HotelCard.PriceDetailsPropTypes;
PriceDetails.defaultProps = _HotelCard.PriceDetailsDefaultProps;
var _default = PriceDetails;
exports.default = _default;